<template>
    <section
        class="show-detail-numbers-snapshot show-detail-snapshot"
        v-if="aggregate"
        :class="{ 'premium-feature-content': !hasAggregate }"
    >
        <div class="border-box-with-title">
            <h4 class="box-title">All Time</h4>

            <ul>
                <li>
                    <h5>Gross</h5>
                    <p>{{ aggregate.gross.total.value / 100 | money }}</p>
                </li>
                <li>
                    <h5>Attendance</h5>
                    <p>{{ aggregate.attendance.total.value | commaNumber }}</p>
                </li>
                <li>
                    <h5>Performances</h5>
                    <p>{{ aggregate.performances.total.value | commaNumber }}</p>
                </li>
                <li>
                    <h5>Previews</h5>
                    <p>{{ aggregate.previews.total.value | commaNumber }}</p>
                </li>
            </ul>
        </div>

        <div class="premium-content-message" v-if="aggregate && !hasAggregate">
            <a
                href="#"
                class="button button-grey button-disabled"
                @click.prevent.stop
            >Historical Data for this Show Coming Soon</a>
        </div>
    </section>
</template>

<script>
export default {
    computed: {
        aggregate() {
            return this.$store.getters['shows/aggregate'](
                this.$route.params.show,
            );
        },
        hasAggregate() {
            return this.$store.getters['shows/hasAggregate'](
                this.$route.params.show,
                'first_preview',
            );
        },
    },
};
</script>
